export default __webpack_public_path__ + "static/locahostacademy-ec3fd16957267ff6ce153d6985f8acc5.svg";